import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface TwitterIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const TwitterIcon = observer('TwitterIcon', ({ className, onClick }: TwitterIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='#072d4f'
            height='24'
            onClick={onClick}
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='fill'
                fillRule='evenodd'
                d='M23 5.09c-.623.898-1.377 1.664-2.261 2.296.009.129.014.321.014.578 0 1.191-.177 2.38-.53 3.568-.355 1.187-.892 2.326-1.613 3.417-.721 1.09-1.58 2.055-2.576 2.894-.995.839-2.196 1.508-3.601 2.008-1.405.5-2.908.749-4.51.749-2.521 0-4.83-.665-6.923-1.994.326.037.689.055 1.089.055 2.094 0 3.96-.632 5.598-1.897-.978-.019-1.852-.314-2.625-.887-.772-.573-1.303-1.304-1.591-2.193.307.046.59.069.851.069.4 0 .796-.05 1.187-.152-1.042-.21-1.906-.722-2.59-1.533-.684-.811-1.026-1.753-1.026-2.825v-.056c.633.349 1.313.537 2.038.564-.614-.403-1.102-.93-1.465-1.581-.363-.65-.545-1.357-.545-2.117 0-.807.205-1.554.615-2.242 1.126 1.366 2.496 2.46 4.11 3.28 1.615.82 3.344 1.276 5.186 1.368-.074-.349-.111-.688-.111-1.018 0-1.228.44-2.275 1.319-3.142C13.92 3.433 14.983 3 16.23 3c1.303 0 2.4.467 3.294 1.402 1.014-.192 1.968-.55 2.862-1.072-.345 1.054-1.005 1.87-1.982 2.447.865-.091 1.73-.32 2.596-.687z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
